import { API_EMPLOYEE_REF_UPD, API_EMPLOYEE_LIST, API_EMPLOYEE_DELETE, API_EMPLOYEE_DETAIL, API_EMPLOYEE_SAVE, API_EMPLOYEE_QUIT_LIST, API_EMPLOYEE_QUIT,
    API_POSITIONASSIGN_LIST, API_POSITIONASSIGN_DELETE, API_POSITIONASSIGN_SAVE, API_GET_USEREXTENDDATAIDS, API_EMPLOYEE_ONTIN_POSITION_LIST,
    API_ROLEASSIGN_LIST, API_ROLEASSIGN_DELETE, API_ROLEASSIGN_SAVE, API_EMPLOYEE_ONTIN_ROLE_LIST, API_SAVE_SON_TEMPDATA, API_GET_SON_TEMPDATA,
    API_EMPLOYEE_LIST_BY_RESOURCEID, API_EMPLOYEE_RESOURCE_DELETE, API_MULT_EMPLOYEE_RESOURCE_SAVE, API_EMPLOYEE_LIST_OF_UNAUTH_RES, API_EMPLOYEE_ALL, API_EMPLOYEE_HANDOVER} from '@/common/constants';
import { get, post, del, put } from '@/utils/http';

export const getEmployeeList = (currentPage = 1, pageSize = 10, keyword) => {
    return get(API_EMPLOYEE_LIST, { currentPage, pageSize, keyword: keyword });
};

export const getEmployeeDetail = (employeeId) => {
    return get(API_EMPLOYEE_DETAIL.replace(':employeeId', employeeId));
};

export const delEmployee = (employeeId) => {
    return del(API_EMPLOYEE_DELETE.replace(':employeeId', employeeId));
};

export const saveEmployee = (employee) => {
    if (employee.id == undefined || employee.id == '') {
        return post(API_EMPLOYEE_SAVE, employee);
    } else {
        return put(API_EMPLOYEE_SAVE, employee);
    }
};
export const handoverEmployee = (param) => {
    return post(API_EMPLOYEE_HANDOVER, param);
};

export const saveSonTempData = (param) => {
    return post(API_SAVE_SON_TEMPDATA, param);
};
export const getSonTempData = (param) => {
    return post(API_GET_SON_TEMPDATA, param);
};
export const updEmployee = (employee) => {
    if (employee.id !== undefined && employee.id !== '') {
        return put(API_EMPLOYEE_SAVE, employee);
    }
};

export const getQuitEmployeeList = (currentPage = 1, pageSize = 10, keyword) => {
    return get(API_EMPLOYEE_QUIT_LIST, { currentPage, pageSize, keyword: keyword });
};

export const quitEmployee = (param) => {
    return put(API_EMPLOYEE_QUIT, param);
};

// 员工岗位关系处理
export const getEmployeeListByPositionId = (currentPage = 1, pageSize = 10, positionId, keyWord) => {
    return get(API_POSITIONASSIGN_LIST, {currentPage, pageSize, positionId: positionId, trueName: keyWord});
};

export const deleteEmployeePosition = (id) => {
    return del(API_POSITIONASSIGN_DELETE.replace(':id', id));
};

export const saveMultEmployeePosition = (employeePosition) => {
    return post(API_POSITIONASSIGN_SAVE, employeePosition);
};

export const getUserExtendDataIds = (param) => {
    return post(API_GET_USEREXTENDDATAIDS, param);
};

export const getEmployeeNotInPositionList = (currentPage = 1, pageSize = 10, positionId, keyWord) => {
    return get(API_EMPLOYEE_ONTIN_POSITION_LIST, {currentPage, pageSize, positionId: positionId, trueName: keyWord});
};

// 员工角色关系处理
export const getEmployeeListByRoleId = (currentPage = 1, pageSize = 10, roleId, keyWord) => {
    return get(API_ROLEASSIGN_LIST, {currentPage, pageSize, roleId: roleId, trueName: keyWord});
};

export const deleteEmployeeRole = (id) => {
    return del(API_ROLEASSIGN_DELETE.replace(':id', id));
};

export const saveMultEmployeeRole = (employeeRole) => {
    return post(API_ROLEASSIGN_SAVE, employeeRole);
};

export const getEmployeeNotInRoleList = (currentPage = 1, pageSize = 10, roleId, keyWord) => {
    return get(API_EMPLOYEE_ONTIN_ROLE_LIST, {currentPage, pageSize, roleId: roleId, trueName: keyWord});
};
// Employee EMPLOYEE employee

// 员工资源管理
export const getEmployeeListByResourceId = (currentPage = 1, pageSize = 10, resourceId, keyWord) => {
    return get(API_EMPLOYEE_LIST_BY_RESOURCEID, {currentPage, pageSize, resourceId: resourceId, trueName: keyWord});
};

export const deleteEmployeeResource = (id) => {
    return del(API_EMPLOYEE_RESOURCE_DELETE.replace(':id', id));
};

export const saveMultEmployeeResource = (employeeRole) => {
    return post(API_MULT_EMPLOYEE_RESOURCE_SAVE, employeeRole);
};

export const getEmployeeListOfUnAuthRes = (currentPage = 1, pageSize = 10, resourceId, keyWord) => {
    return get(API_EMPLOYEE_LIST_OF_UNAUTH_RES, {currentPage, pageSize, resourceId: resourceId, trueName: keyWord});
};
// 获取所有员工
export const getAllUserList = (param) => {
    return get(API_EMPLOYEE_ALL, param);
};
// 批量更新人员扩展表的跨年统计字段值
export const updEmployeeRefData = () => {
    return post(API_EMPLOYEE_REF_UPD, {});
};



// WEBPACK FOOTER //
// ./src/data-model/system/employee-model.js